import { render, staticRenderFns } from "./MainNavigationReceiverUi.vue?vue&type=template&id=a834e088&"
import script from "./MainNavigationReceiverUi.vue?vue&type=script&lang=js&"
export * from "./MainNavigationReceiverUi.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationReceiverUi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports